import React from 'react';

/**
 * CSS mockup of the six volumes, in the product palette.
 * Placeholder until the real box-set render is ready — then swap this
 * component for an <img>.
 */
const volumes = [{
  n: '01',
  title: 'Welcome to the Room',
  range: 'Activities 1–15',
  band: 'bg-sage'
}, {
  n: '02',
  title: 'Move Together',
  range: 'Activities 16–30',
  band: 'bg-gold'
}, {
  n: '03',
  title: 'Hands with Purpose',
  range: 'Activities 31–45',
  band: 'bg-smoke'
}, {
  n: '04',
  title: 'Share a Story',
  range: 'Activities 46–60',
  band: 'bg-sage'
}, {
  n: '05',
  title: 'Sensory Afternoons',
  range: 'Activities 61–75',
  band: 'bg-gold'
}, {
  n: '06',
  title: 'Room to Room',
  range: 'Activities 76–90',
  band: 'bg-smoke'
}];
export function VolumeStack({
  className = ''
}: {
  className?: string;
}) {
  return <div role="img" aria-label="Memory Care Activity Ready: six volumes, from Welcome to the Room (activities 1 to 15) to Room to Room (activities 76 to 90)" className={`relative w-full select-none ${className}`} data-id="element-358" data-mp="1dr7z9h9wgylp">
      <span aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center font-display italic font-semibold text-gold/15 leading-none text-[42vw] sm:text-[240px] lg:text-[260px]" data-id="element-359" data-mp="3lguikjywxs6l">
        90
      </span>

      <div className="relative flex items-end justify-center px-2 pb-8 pt-10" data-id="element-360" data-mp="3462diwkoa9o">
        {volumes.map((v, i) => {
        const offset = i - 2.5;
        return <div key={v.n} className="relative -ml-[8%] first:ml-0 w-[25%] aspect-[3/4] overflow-hidden rounded-[6px] bg-cream shadow-cover ring-1 ring-black/5" style={{
          transform: `rotate(${offset * 4.5}deg) translateY(${Math.abs(offset) * 7}px)`,
          zIndex: 10 - Math.round(Math.abs(offset))
        }} data-id="element-361" data-mp="32l4d2mrrudny" data-mpi={i}>
              <div className="h-[40%] bg-plum px-[9%] pt-[11%]" data-id="element-362" data-mp="qvl9dozanfr9">
                <span className="block text-[clamp(5px,1.3vw,9px)] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-363" data-mp="vr0iy4q9qphv">
                  Volume {v.n}
                </span>
                <span className="mt-[6%] block font-display italic text-[clamp(6px,1.5vw,11px)] leading-tight text-white/85" data-id="element-364" data-mp="2numr0t17h2r6">
                  Memory Care Activity Ready
                </span>
              </div>
              <div className="px-[9%] pt-[10%]" data-id="element-365" data-mp="2wvky5k6xxqdz">
                <span className="block font-display font-bold text-plum text-[clamp(8px,2.1vw,15px)] leading-[1.1]" data-id="element-366" data-mp="2wsq9fggw9jer">
                  {v.title}
                </span>
                <span className="mt-[8%] block text-[clamp(5px,1.2vw,9px)] font-semibold uppercase tracking-[0.14em] text-ink-soft" data-id="element-367" data-mp="247gqit4t738n">
                  {v.range}
                </span>
              </div>
              {/* thin rule: the ladder rung, the recurring motif of the volumes */}
              <span className="absolute left-[9%] right-[9%] bottom-[18%] h-px bg-gold" data-id="element-368" data-mp="1qd65als0tr7c" />
              <span className={`absolute inset-x-0 bottom-0 h-[8%] ${v.band}`} data-id="element-369" data-mp="1lecvb3by0ibx" />
            </div>;
      })}
      </div>
    </div>;
}